import { useCallback, useState } from 'react';

import AddchartOutlined from '@mui/icons-material/AddchartOutlined';
import { IconButton, Tooltip } from '@mui/material';

import useUserDetails from '@/hooks/useUserDetails';
import type { BaseTabType } from '@/types/markets';

import AddToDashboardMenu from './AddToDashboardMenu';

const AddToDashboardButton = ({ tab }: { tab: BaseTabType }) => {
  const { isUserExpired } = useUserDetails();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(prev => (prev ? null : event.currentTarget));
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <Tooltip
        slotProps={{
          popper: {
            sx: { zIndex: 9999 }
          }
        }}
        title='Add widget to dashboard'
      >
        <span style={{ display: 'inline-flex' }}>
          <IconButton
            disabled={isUserExpired}
            sx={{
              width: 30,
              height: 48,
              p: 0,
              minWidth: 30,
              borderRadius: 0,
              backgroundColor: 'secondary.main'
            }}
            onClick={handleClick}
          >
            <AddchartOutlined sx={{ fontSize: '14px' }} />
          </IconButton>
        </span>
      </Tooltip>

      <AddToDashboardMenu
        anchorEl={anchorEl}
        open={menuOpen}
        tab={tab}
        onClose={handleClose}
      />
    </>
  );
};

export default AddToDashboardButton;
